import actionTypes from '../actions/actionTypes';

export default function(state = 'APP_TITLE', action = {}) {
    if (action.type === actionTypes.PAGE_TITLE) {
        return action.value;
    } else {
        return state;
    }
}
